import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

export function SeoTitle({ t }) {
    const title = `${t('flight.title')}${FINN?.travel?.seoDestination === '' ? '' : ` til ${FINN.travel.seoDestination}`}`;

    return FINN?.travel?.enableSeo ? (
        <section className="panel grid">
            <h1 className="u-t2 u-pv8 u-ph8">
                <svg width={60} height={50} className="u-pt4 u-valign-middle u-float-left" aria-hidden="true">
                    <title>FINN reise</title>
                    <path
                        fill="#06befb"
                        fillRule="evenodd"
                        d="M41.969 13.522L28.142 17.27l.754-2.28a.807.807 0 0 0-.502-1.018.796.796 0 0
        0-1.008.507l-3.794 11.465a3.532 3.532 0 0 1-2.43 2.313l-3.229.875 1.398-12.208a.803.803 0 0 0-.699-.892.794.794 0 0
        0-.882.706l-.395 3.453-7.494 1.99L2.683 11.56l.605-.119a4.407 4.407 0 0 1 4.186 1.045l2.174 2.031L33.257 8.12a6.93 6.93 0 0 1
        3.693.018l1.48.416-3.405.923a.805.805 0 0 0-.563.986.797.797 0 0 0 .975.569l6.011-1.63.296.083c.777.22 1.389.845 1.598 1.632a1.97
        1.97 0 0 1-1.373 2.406zM13.356 6.608l3.229-.875a3.495 3.495 0 0 1 3.247.773l3.076 2.751-6.343 1.72-3.21-4.37zm31.523 4.091a3.921
        3.921 0 0 0-2.708-2.765l-.23-.065a.77.77 0 0 0-.403-.113l-4.161-1.17a8.485 8.485 0 0 0-4.533-.022l-8.093 2.193L20.887 5.3a5.06
        5.06 0 0 0-4.715-1.122l-5.49 1.488 4.228 5.758-4.826 1.31-1.53-1.43c-1.536-1.435-3.658-1.965-5.622-1.43L0 10.44l9.18 13.586
        7.978-2.12-1.076 9.393 5.492-1.489a5.13 5.13 0 0 0 3.528-3.357l2.434-7.354 14.845-4.022c1.882-.51 3.003-2.476 2.498-4.379z"
                    />
                </svg>
                {title}
            </h1>
        </section>
    ) : null;
}

SeoTitle.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(SeoTitle);
